export default __webpack_public_path__ + "static/media/cloud@3x.81b320d4.png";